import React from "react"
import moment from "moment"

import {FormattedMessage} from "@irati/utils/lang"
import {Wallet} from "@irati/types"
import Spacing from "@irati/ui/src/Spacing"
import DateHeader from "../StatementItems/DateHeader"
import {DesktopHeader, StatementItemsWrapper, StyledStatementItems, StyledTabs} from "./styled"
import {NextTopupStatementItem} from "../StatementItems/StatementItem/NextTopupStatementItem"

interface Props {
  wallet: Wallet
}

export default function FlexiPoints({wallet}: Props) {
  if (!wallet) return null
  const nextTopup = wallet.nextTopup?.date

  return (
    <Spacing marginTop={4}>
      <DesktopHeader marginBottom={2}>
        <FormattedMessage id="wallet.transactions.title.flexiPoints" />
      </DesktopHeader>
      {!nextTopup ? (
        <StyledStatementItems wallet={wallet} />
      ) : (
        <StyledTabs
          mountOnEnter
          tabs={[
            {
              key: "completed",
              title: <FormattedMessage id="wallet.flexiwallet.transactions.heading.completed" />,
              component: <StyledStatementItems wallet={wallet} />
            },
            {
              key: "scheduled",
              title: <FormattedMessage id="wallet.flexiwallet.transactions.heading.scheduled" />,
              component: (
                <StatementItemsWrapper>
                  <DateHeader date={moment(nextTopup)} />
                  <NextTopupStatementItem wallet={wallet} />
                </StatementItemsWrapper>
              )
            }
          ]}
        />
      )}
    </Spacing>
  )
}
